import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, withCtx as _withCtx, vModelText as _vModelText, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title-section" }
const _hoisted_3 = { class: "restaurant-selector" }
const _hoisted_4 = {
  key: 0,
  disabled: ""
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "refresh-time-info" }
const _hoisted_7 = { class: "exclude-paid-toggle" }
const _hoisted_8 = { class: "order-filter-toggle" }
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = { class: "nav-dropdown" }
const _hoisted_11 = { class: "filter-dropdown" }
const _hoisted_12 = { class: "filter-btn-selection" }
const _hoisted_13 = { class: "filter-menu-section" }
const _hoisted_14 = { class: "filter-menu-title" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "filter-menu-footer" }
const _hoisted_17 = { class: "order-view active" }
const _hoisted_18 = { class: "order-cards" }
const _hoisted_19 = ["data-order-id"]
const _hoisted_20 = {
  key: 0,
  class: "self-pickup-action-row"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "self-pickup-time" }
const _hoisted_23 = { class: "order-header-row" }
const _hoisted_24 = { class: "restaurant-name" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "order-timestamp-row" }
const _hoisted_27 = { class: "order-time-info" }
const _hoisted_28 = { class: "order-timestamp" }
const _hoisted_29 = ["aria-label"]
const _hoisted_30 = { class: "order-amount" }
const _hoisted_31 = { class: "order-header-details" }
const _hoisted_32 = { class: "order-info-left" }
const _hoisted_33 = ["onClick", "onKeydown"]
const _hoisted_34 = { class: "order-id-prefix" }
const _hoisted_35 = { class: "order-id-suffix" }
const _hoisted_36 = { class: "order-table-row" }
const _hoisted_37 = {
  class: "order-table notranslate",
  translate: "no"
}
const _hoisted_38 = ["title", "onClick"]
const _hoisted_39 = {
  key: 0,
  class: "order-reservation-count"
}
const _hoisted_40 = {
  key: 1,
  class: "delivery-address"
}
const _hoisted_41 = {
  key: 2,
  class: "order-remark"
}
const _hoisted_42 = { class: "order-payment-actions" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "order-items" }
const _hoisted_45 = { class: "order-item-content" }
const _hoisted_46 = { class: "item-info" }
const _hoisted_47 = { class: "item-name" }
const _hoisted_48 = {
  key: 0,
  class: "item-cook"
}
const _hoisted_49 = { class: "item-quantity" }
const _hoisted_50 = ["disabled", "onClick"]
const _hoisted_51 = { class: "order-footer" }
const _hoisted_52 = { class: "order-status" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 1,
  class: "no-order-tip"
}
const _hoisted_56 = { class: "quick-find-dialog" }
const _hoisted_57 = ["aria-label"]
const _hoisted_58 = { class: "quick-find-keypad" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "quick-find-dialog-actions" }
const _hoisted_61 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
}
const _hoisted_62 = { class: "seat-number-modal bg-white rounded-xl p-5 w-full flex flex-col overflow-hidden" }
const _hoisted_63 = { class: "flex justify-between items-center mb-4 flex-shrink-0" }
const _hoisted_64 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = {
  key: 0,
  class: "py-10 text-center text-gray-500"
}
const _hoisted_67 = {
  key: 1,
  class: "py-10 text-center text-gray-500"
}
const _hoisted_68 = {
  key: 2,
  class: "seat-table-grid"
}
const _hoisted_69 = ["disabled", "onClick"]
const _hoisted_70 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_71 = {
  key: 1,
  class: "fas fa-check"
}
const _hoisted_72 = {
  key: 1,
  class: "reservation-table-modal-mask fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
}
const _hoisted_73 = { class: "reservation-table-modal bg-white rounded-xl p-6 w-full max-w-lg flex flex-col overflow-hidden" }
const _hoisted_74 = { class: "flex justify-between items-center mb-4 flex-shrink-0" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = {
  key: 0,
  class: "py-10 text-center text-gray-500"
}
const _hoisted_77 = {
  key: 1,
  class: "py-10 text-center text-gray-500"
}
const _hoisted_78 = {
  key: 2,
  class: "reservation-table-list grid grid-cols-2 gap-3 overflow-y-auto pr-1 flex-1 min-h-0"
}
const _hoisted_79 = ["disabled", "onClick"]
const _hoisted_80 = { class: "font-bold text-lg" }
const _hoisted_81 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_82 = { class: "flex space-x-3 pt-5 mt-5 border-t flex-shrink-0" }
const _hoisted_83 = ["disabled"]
const _hoisted_84 = ["disabled"]
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = {
  key: 2,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
}
const _hoisted_88 = { class: "bg-white rounded-xl p-6 w-96 max-w-md max-h-[90vh] overflow-y-auto" }
const _hoisted_89 = { class: "flex justify-between items-center mb-4" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { class: "mb-4 p-3 bg-gray-50 rounded-lg" }
const _hoisted_92 = { class: "flex justify-between items-center mb-2" }
const _hoisted_93 = { class: "font-medium" }
const _hoisted_94 = { class: "flex justify-between items-center mb-2" }
const _hoisted_95 = { class: "font-medium" }
const _hoisted_96 = { class: "flex justify-between items-center" }
const _hoisted_97 = { class: "text-xl font-bold text-red-500" }
const _hoisted_98 = { class: "space-y-4" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = ["value"]
const _hoisted_101 = ["disabled"]
const _hoisted_102 = { class: "flex space-x-3 pt-6 mt-6 border-t" }
const _hoisted_103 = ["disabled"]
const _hoisted_104 = ["disabled"]
const _hoisted_105 = { key: 0 }
const _hoisted_106 = { key: 1 }
const _hoisted_107 = {
  key: 3,
  class: "fixed inset-0 bg-black z-50 flex flex-col"
}
const _hoisted_108 = { class: "flex-1 relative overflow-hidden w-full h-full" }
const _hoisted_109 = {
  key: 0,
  class: "absolute inset-0 pointer-events-none z-20"
}
const _hoisted_110 = {
  key: 0,
  class: "bg-black bg-opacity-80 px-4 py-3"
}
const _hoisted_111 = { class: "text-sm font-medium" }
const _hoisted_112 = {
  key: 4,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
}
const _hoisted_113 = { class: "bg-white rounded-xl p-6 w-96 max-w-md" }
const _hoisted_114 = { class: "mb-6" }
const _hoisted_115 = {
  key: 0,
  class: "text-red-500 text-sm mt-2"
}
const _hoisted_116 = { class: "flex flex-col space-y-3" }
const _hoisted_117 = ["disabled"]
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { key: 1 }
const _hoisted_120 = ["disabled"]
const _hoisted_121 = ["disabled"]
const _hoisted_122 = { class: "flex h-full flex-col overflow-hidden bg-white" }
const _hoisted_123 = { class: "flex shrink-0 items-center justify-between border-b px-4 py-3" }
const _hoisted_124 = { class: "min-h-0 flex-1 overflow-y-auto" }

import { ref, computed, onMounted, onUnmounted, nextTick } from 'vue';
  import { useRouter } from 'vue-router';
  import { fetchShopList, fetchShopDetail, fetchTableList } from '@/service/base';
  import {
    getOrderList,
    getOrder,
    insertOrderPayment,
    auditOrder,
    completeOrder,
    editOrderTable,
    editSeatNumber,
    getOrderTableList,
  } from '@/service/order';
  import { outFood, foodUp } from '@/service/food';
  import { FoodList, OrderListItemModel, OrderTableListItemModel } from '@/model/order';
  import dayjs from 'dayjs';
  import { dateTimeFormat } from '@/utils/utils';
  import { scanPayment, refreshScanPayment } from '@/service/payment';
  import { Html5Qrcode } from 'html5-qrcode';
  import { useCurrentEmployee } from '@/composables/useCurrentEmployee';
  import OrderDetailView from '@/views/order/OrderDetailView.vue';

  type OrderTypeFilter = 'dine-in' | 'self-pickup' | 'delivery' | 'packed' | 'reservation';

  interface OrderTypeFilterOption {
    value: OrderTypeFilter;
    label: string;
    icon: string;
    dineType: number;
  }

  const LAST_ORDER_CREATE_TIME_PREFIX = 'kitchen_order_last_create_time_';
  const SELECTED_SHOP_KEY = 'table_manage_selected_shop';

  // 保存选中的餐厅到localStorage
  
export default /*@__PURE__*/_defineComponent({
  __name: 'KitchenOrderView',
  setup(__props) {

  const router = useRouter();
  const { employeeId, employeeName } = useCurrentEmployee();
  const currentTimeMs = ref(Date.now());
  const showOrderDetails = ref(false);
  const detailOrder = ref<OrderListItemModel>();
  const openOrderDetails = (order: OrderListItemModel): void => {
    if (!order.orderId) return;
    detailOrder.value = order;
    showOrderDetails.value = true;
  };
  const onOrderDetailsClosed = (): void => {
    detailOrder.value = undefined;
    if (selectedShopId.value) void fetchOrderList(Number(selectedShopId.value));
  };

  // 新增：新订单提示音
  let newOrderAudio: HTMLAudioElement | null = null;
  const initNewOrderAudio = () => {
    try {
      const src = new URL('@/assets/audio/new_order.mp3', import.meta.url).href;
      newOrderAudio = new Audio(src);
      newOrderAudio.preload = 'auto';
      newOrderAudio.volume = 1.0;
    } catch (e) {
      console.warn('新订单提示音初始化失败:', e);
    }
  };
  const playNewOrderSound = async () => {
    try {
      if (newOrderAudio) {
        newOrderAudio.currentTime = 0;
        await newOrderAudio.play();
      }
    } catch (e) {
      console.warn('播放新订单提示音失败:', e);
    }
  };

  // 响应式数据
  const shopList = ref<any[]>([]);
  const selectedShopId = ref<number | null>(null);
  const orderList = ref<Array<OrderListItemModel>>([]);
  const showFilterMenu = ref(false);
  const showNavMenu = ref(false);
  const excludeUnPaid = ref(false);
  const onlyToday = ref(false);
  const contentContainerRef = ref<HTMLDivElement | null>(null);
  const quickFindVisible = ref(false);
  const quickFindInput = ref('');
  const highlightedOrderId = ref<number | null>(null);
  const pendingQuickFindOrderId = ref<number | null>(null);
  let quickFindHighlightTimer: ReturnType<typeof setTimeout> | null = null;

  const orderTypeFilterOptions: OrderTypeFilterOption[] = [
    { value: 'dine-in', label: '堂食', icon: 'fa-utensils', dineType: 1 },
    { value: 'self-pickup', label: '自提', icon: 'fa-shopping-bag', dineType: 2 },
    { value: 'delivery', label: '外卖', icon: 'fa-motorcycle', dineType: 3 },
    { value: 'packed', label: '打包', icon: 'fa-box', dineType: 4 },
    { value: 'reservation', label: '预定', icon: 'fa-calendar-check', dineType: 5 },
  ];
  const selectedFilterTypes = ref<OrderTypeFilter[]>(
    orderTypeFilterOptions.map((option) => option.value),
  );

  const reservationTableModalVisible = ref(false);
  const currentReservationOrder = ref<OrderListItemModel | null>(null);
  const availableReservationTables = ref<OrderTableListItemModel[]>([]);
  const selectedReservationTableId = ref<number | null>(null);
  const isLoadingReservationTables = ref(false);
  const isChangingReservationTable = ref(false);

  const seatNumberModalVisible = ref(false);
  const currentSeatOrder = ref<OrderListItemModel | null>(null);
  const seatTableList = ref<OrderTableListItemModel[]>([]);
  const selectedSeatNumber = ref('');
  const isLoadingSeatTables = ref(false);
  const isEditingSeatNumber = ref(false);
  const excludedSeatTableNames = new Set(['POS下单', '预定', '外卖', '自提']);

  const closeSeatNumberModal = () => {
    if (isEditingSeatNumber.value) return;
    seatNumberModalVisible.value = false;
    currentSeatOrder.value = null;
    seatTableList.value = [];
    selectedSeatNumber.value = '';
  };

  const openSeatNumberModal = async (order: OrderListItemModel) => {
    if (!order.orderId || !order.shopId) {
      showToast('订单信息不完整，无法修改座位号');
      return;
    }

    currentSeatOrder.value = order;
    selectedSeatNumber.value = order.seatNumber || '';
    seatTableList.value = [];
    seatNumberModalVisible.value = true;
    isLoadingSeatTables.value = true;

    try {
      const response = await getOrderTableList({
        pageNum: 1,
        pageSize: 999,
        data: { shopId: order.shopId },
      });
      if (response.code === 200) {
        seatTableList.value = (response.result.list || []).filter(
          (table) => !excludedSeatTableNames.has(table.tableName?.trim() || ''),
        );
      } else {
        showToast(response.msg || '加载桌位失败');
      }
    } catch (error) {
      console.error('加载座位号桌位列表失败:', error);
      showToast('加载桌位失败，请稍后重试');
    } finally {
      isLoadingSeatTables.value = false;
    }
  };

  const selectSeatNumber = async (table: OrderTableListItemModel) => {
    if (isEditingSeatNumber.value || !table.tableName) return;

    const order = currentSeatOrder.value;
    if (!order?.orderId) {
      showToast('订单信息不完整，无法修改座位号');
      return;
    }

    selectedSeatNumber.value = table.tableName;
    isEditingSeatNumber.value = true;
    try {
      const response = await editSeatNumber({
        orderId: order.orderId,
        seatNumber: table.tableName,
      });
      if (response.code === 200) {
        order.seatNumber = table.tableName;
        showToast(`座位号已修改为 ${table.tableName}`);
        isEditingSeatNumber.value = false;
        closeSeatNumberModal();
      } else {
        showToast(response.msg || '修改座位号失败');
      }
    } catch (error) {
      console.error('修改订单座位号失败:', error);
      showToast('修改座位号失败，请稍后重试');
    } finally {
      isEditingSeatNumber.value = false;
    }
  };

  // 新增：自动刷新相关状态
  const lastRefreshTime = ref('');
  let autoRefreshTimer: NodeJS.Timeout | null = null;

  // 新增：支付确认相关状态
  const paymentConfirmModalVisible = ref(false);
  const isConfirmingPayment = ref(false);
  const selectedPaymentMethod = ref(4); // 默认选择POS支付，如果有B扫C收款会自动更新
  const paymentRemark = ref('');
  const isOnlinePayment = ref(false); // 是否为线上支付
  const currentPaymentOrder = ref<any | null>(null); // 当前确认支付的订单

  // 支付方式列表（计算属性）
  const paymentMethods = computed(() => {
    const methods = [
      { value: 4, name: 'POS支付' },
      { value: 5, name: '公司挂账' },
      { value: 7, name: '现金支付' },
    ];
    // 如果支持在线支付，添加B扫C收款选项
    if (isOnlinePayment.value) {
      methods.unshift({ value: 3, name: 'B扫C收款' });
    }
    return methods;
  });

  // 扫码支付相关状态
  const scanPaymentModalVisible = ref(false);
  const isScanning = ref(false);
  const scanPaymentRemark = ref('');
  const scanStatus = ref('');
  const scanStatusClass = ref('');
  const scanPaymentFailModalVisible = ref(false); // 扫码支付失败确认模态框
  const scanPaymentFailErrorMsg = ref(''); // 扫码支付失败错误信息
  const isRefreshingPayment = ref(false); // 是否正在刷新支付状态
  const isSubmittingScanPayment = ref(false);
  let html5QrCode: Html5Qrcode | null = null;

  // 新增：本地存储最近订单创建时间（按店铺）
  const getLastCreateTimeKey = (shopId: number) => `${LAST_ORDER_CREATE_TIME_PREFIX}${shopId}`;
  const getStoredLastCreateTime = (shopId: number): number | null => {
    try {
      const v = localStorage.getItem(getLastCreateTimeKey(shopId));
      return v ? parseInt(v, 10) : null;
    } catch {
      return null;
    }
  };
  const setStoredLastCreateTime = (shopId: number, ms: number) => {
    try {
      localStorage.setItem(getLastCreateTimeKey(shopId), String(ms));
    } catch (e) {
      console.warn('无法保存最近创建时间到localStorage:', e);
    }
  };

  // localStorage key for selected shop（与桌位管理共用，确保页面间店铺选择一致）
  const saveSelectedShop = (shopId: number) => {
    try {
      localStorage.setItem(SELECTED_SHOP_KEY, shopId.toString());
    } catch (error) {
      console.warn('无法保存餐厅选择到localStorage:', error);
    }
  };

  // 从localStorage读取选中的餐厅
  const loadSelectedShop = (): number | null => {
    try {
      const savedShopId = localStorage.getItem(SELECTED_SHOP_KEY);
      return savedShopId ? parseInt(savedShopId, 10) : null;
    } catch (error) {
      console.warn('无法从localStorage读取餐厅选择:', error);
      return null;
    }
  };

  // 验证餐厅是否存在于当前餐厅列表中
  const isValidShop = (shopId: number): boolean => {
    return shopList.value.some((shop) => shop.shopId === shopId);
  };

  const getCreateTimeMs = (order: OrderListItemModel): number => {
    const createTimeMs = order.createTime ? new Date(order.createTime).getTime() : NaN;
    return Number.isNaN(createTimeMs) ? Number.MAX_SAFE_INTEGER : createTimeMs;
  };

  const getAppointmentTimeMs = (order: OrderListItemModel): number | null => {
    if (!order.selfPickDate || !order.selfPickTime) return null;

    const dateMatch = order.selfPickDate.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const startTime = order.selfPickTime.split('-')[0]?.trim();
    const timeMatch = startTime?.match(/^(\d{2}):(\d{2})$/);
    if (!dateMatch || !timeMatch) return null;

    const [, year, month, day] = dateMatch;
    const [, hour, minute] = timeMatch;
    const appointmentTime = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
    );

    const isValidAppointmentTime =
      appointmentTime.getFullYear() === Number(year) &&
      appointmentTime.getMonth() === Number(month) - 1 &&
      appointmentTime.getDate() === Number(day) &&
      appointmentTime.getHours() === Number(hour) &&
      appointmentTime.getMinutes() === Number(minute);

    return isValidAppointmentTime ? appointmentTime.getTime() : null;
  };

  const getEffectiveOrderTimeMs = (order: OrderListItemModel): number => {
    const usesAppointmentTime = [2, 3, 5].includes(order.dineType ?? 0);
    if (usesAppointmentTime) {
      return getAppointmentTimeMs(order) ?? getCreateTimeMs(order);
    }
    return getCreateTimeMs(order);
  };

  const getLocalDateString = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const isTodayOrder = (order: OrderListItemModel): boolean => {
    const today = getLocalDateString(new Date());
    if ([2, 3, 5].includes(order.dineType ?? 0)) {
      return order.selfPickDate?.trim() === today;
    }

    if (!order.createTime) return false;
    const createTime = new Date(order.createTime);
    return !Number.isNaN(createTime.getTime()) && getLocalDateString(createTime) === today;
  };

  // 计算属性
  const isAllFilterTypesSelected = computed(
    () => selectedFilterTypes.value.length === orderTypeFilterOptions.length,
  );

  const filterButtonText = computed(() => {
    if (isAllFilterTypesSelected.value) return '全部订单';
    if (selectedFilterTypes.value.length === 0) return '未选择';

    return orderTypeFilterOptions
      .filter((option) => selectedFilterTypes.value.includes(option.value))
      .map((option) => option.label)
      .join('、');
  });

  const filteredOrderList = computed(() => {
    let result = [...orderList.value];

    if (!isAllFilterTypesSelected.value) {
      const selectedDineTypes = new Set(
        orderTypeFilterOptions
          .filter((option) => selectedFilterTypes.value.includes(option.value))
          .map((option) => option.dineType),
      );
      result = result.filter((order) => selectedDineTypes.has(order.dineType ?? 0));
    }

    if (onlyToday.value) {
      result = result.filter(isTodayOrder);
    }

    return result.sort((a, b) => {
      const effectiveTimeDifference = getEffectiveOrderTimeMs(a) - getEffectiveOrderTimeMs(b);
      if (effectiveTimeDifference !== 0) return effectiveTimeDifference;

      const createTimeDifference = getCreateTimeMs(a) - getCreateTimeMs(b);
      if (createTimeDifference !== 0) return createTimeDifference;

      return (a.orderId ?? Number.MAX_SAFE_INTEGER) - (b.orderId ?? Number.MAX_SAFE_INTEGER);
    });
  });

  const clearQuickFind = () => {
    if (quickFindHighlightTimer) {
      clearTimeout(quickFindHighlightTimer);
      quickFindHighlightTimer = null;
    }
    highlightedOrderId.value = null;
  };

  const openQuickFind = () => {
    quickFindInput.value = '';
    quickFindVisible.value = true;
  };

  const appendQuickFindDigit = (digit: string) => {
    if (!/^\d$/.test(digit) || !quickFindVisible.value) return;
    quickFindInput.value = quickFindInput.value.length === 4 ? digit : quickFindInput.value + digit;
    if (quickFindInput.value.length === 4) findQuickOrder();
  };

  const focusQuickOrder = async (orderId: number) => {
    highlightedOrderId.value = orderId;
    if (quickFindHighlightTimer) clearTimeout(quickFindHighlightTimer);
    await nextTick();
    const card = contentContainerRef.value?.querySelector<HTMLElement>(
      `.order-card[data-order-id="${orderId}"]`,
    );
    card?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    quickFindHighlightTimer = setTimeout(() => {
      highlightedOrderId.value = null;
      quickFindHighlightTimer = null;
    }, 3000);
  };

  const onQuickFindClosed = () => {
    if (pendingQuickFindOrderId.value === null) return;
    const orderId = pendingQuickFindOrderId.value;
    pendingQuickFindOrderId.value = null;
    if (filteredOrderList.value.some((order) => order.orderId === orderId)) {
      void focusQuickOrder(orderId);
    } else {
      clearQuickFind();
    }
  };

  const findQuickOrder = () => {
    if (!/^\d{4}$/.test(quickFindInput.value)) {
      showToast('请输入订单号后四位数字');
      return;
    }
    const matches = filteredOrderList.value.filter(
      (order) => order.orderId !== undefined && order.orderNo?.slice(-4) === quickFindInput.value,
    );
    if (matches.length === 0) {
      showToast('未找到订单，请检查尾号或当前筛选条件');
      return;
    }
    const orderId = matches[0].orderId;
    if (orderId === undefined) return;
    clearQuickFind();
    pendingQuickFindOrderId.value = orderId;
    quickFindVisible.value = false;
  };

  // 方法
  const formatDateTime = (timestamp?: string | Date) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return '';
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${month}-${day} ${hour}:${minute}`;
  };

  const getElapsedMinutes = (timestamp?: string | Date): number | null => {
    if (!timestamp) return null;
    const createdAtMs = new Date(timestamp).getTime();
    if (Number.isNaN(createdAtMs)) return null;
    return Math.max(0, Math.floor((currentTimeMs.value - createdAtMs) / 60000));
  };

  const getElapsedTimeClass = (timestamp?: string | Date) => {
    const minutes = getElapsedMinutes(timestamp);
    if (minutes !== null && minutes > 15) return 'elapsed-danger';
    if (minutes !== null && minutes > 10) return 'elapsed-warning';
    return '';
  };

  const foodDisplayName = (item: FoodList): string => {
    const spec = item.foodSpecName?.trim();
    return spec && spec !== '标准' ? `${item.foodName}（${spec}）` : item.foodName;
  };

  const isFoodCancelled = (item: FoodList): boolean => Number(item.status) === 999;

  const getActiveFoods = (order: OrderListItemModel): FoodList[] =>
    (order.foodList || []).filter((item) => !isFoodCancelled(item));

  const getOrderStatus = (order: OrderListItemModel) => {
    if (!order.foodList || order.foodList.length === 0) {
      return '状态: 待出餐';
    }

    const activeFoods = getActiveFoods(order);
    const totalItems = activeFoods.length;
    const completedItems = activeFoods.filter((item) => item.status === 9).length;

    if (totalItems === 0) return '状态: 菜品已全部取消';

    if (completedItems === 0) {
      return '状态: 待出餐';
    } else if (completedItems === totalItems) {
      return '状态: 已出餐';
    } else {
      return `状态: 部分出餐 (${completedItems}/${totalItems})`;
    }
  };

  // 新增：获取用餐类型显示文本
  const getDineTypeText = (order: OrderListItemModel) => {
    const dineTypeMap = {
      1: '堂食',
      2: '自提',
      3: '外卖',
      4: '打包',
      5: '预定',
    };
    return dineTypeMap[order.dineType as keyof typeof dineTypeMap] || '';
  };

  const getDineTypeClass = (order: OrderListItemModel) => {
    const dineTypeClassMap = {
      1: 'dine-in',
      2: 'self-pickup',
      3: 'delivery',
      4: 'packed',
      5: 'reservation',
    };
    return dineTypeClassMap[order.dineType as keyof typeof dineTypeClassMap] || '';
  };

  // 新增：判断是否是自提订单（根据tableTag）
  const isSelfPickupOrder = (order: OrderListItemModel) => {
    return order.dineType === 2 || Boolean(order.tableTag && order.tableTag.includes('自提'));
  };

  const isReservationOrder = (order: OrderListItemModel) => {
    return order.dineType === 5;
  };

  const isConvertedReservationOrder = (order: OrderListItemModel) => {
    return order.tableTag === '预定' && order.tableName !== '预定';
  };

  const getDisplayPickCode = (order: OrderListItemModel) => {
    if (
      isSelfPickupOrder(order) ||
      isReservationOrder(order) ||
      order.pickCode === order.orderNo?.slice(-4)
    ) {
      return '';
    }
    return order.pickCode || '';
  };

  const getOrderNoPrefix = (orderNo?: string) => {
    return orderNo?.slice(0, -4) || '';
  };

  const getOrderNoSuffix = (orderNo?: string) => {
    return orderNo?.slice(-4) || '';
  };

  const isDeliveryOrder = (order: OrderListItemModel) => {
    return order.dineType === 3;
  };

  const shouldShowAppointmentTime = (order: OrderListItemModel) => {
    return (
      isSelfPickupOrder(order) ||
      isDeliveryOrder(order) ||
      isReservationOrder(order) ||
      isConvertedReservationOrder(order)
    );
  };

  const getAppointmentTimeLabel = (order: OrderListItemModel) => {
    if (isDeliveryOrder(order)) return '外卖';
    if (isReservationOrder(order) || isConvertedReservationOrder(order)) return '预定';
    return '自提';
  };

  // 新增：判断是否显示发送到厨房按钮（预约订单且未确认）
  const shouldShowSendToKitchen = (order: OrderListItemModel) => {
    return (
      (isSelfPickupOrder(order) || isDeliveryOrder(order) || isReservationOrder(order)) &&
      order.orderStatus === 1
    );
  };

  // 新增：解析预约时间并检查是否需要确认
  const checkSelfPickupTime = (order: OrderListItemModel): boolean => {
    try {
      const selfPickDate = order.selfPickDate || '';
      const selfPickTime = order.selfPickTime || '';
      const appointmentLabel = getAppointmentTimeLabel(order);

      // 如果没有预约时间信息，阻止操作并提示
      if (!selfPickDate || !selfPickTime) {
        showToast(`没有${appointmentLabel}时间，无法发送到厨房`);
        return false;
      }

      // 解析自提时间段，例如 "17:00-18:00"
      const timeParts = selfPickTime.split('-');
      if (timeParts.length !== 2) {
        console.warn(`${appointmentLabel}时间格式无效:`, selfPickTime);
        showToast(`${appointmentLabel}时间格式无效，无法发送到厨房`);
        return false;
      }

      const startTime = timeParts[0].trim(); // 开始时间 "17:00"
      const endTime = timeParts[1].trim(); // 结束时间 "18:00"

      // 组合成完整的日期时间字符串
      const startDateTimeStr = `${selfPickDate} ${startTime}`;
      const endDateTimeStr = `${selfPickDate} ${endTime}`;

      // 解析为Date对象
      const startDateTime = new Date(startDateTimeStr);
      const endDateTime = new Date(endDateTimeStr);

      // 检查日期是否有效
      if (isNaN(startDateTime.getTime()) || isNaN(endDateTime.getTime())) {
        console.warn(`${appointmentLabel}时间格式无效:`, startDateTimeStr, endDateTimeStr);
        showToast(`${appointmentLabel}时间格式无效，无法发送到厨房`);
        return false;
      }

      // 获取当前时间
      const now = new Date();

      // 计算最早允许操作时间：开始时间前2小时
      const earliestAllowedTime = new Date(startDateTime.getTime() - 2 * 60 * 60 * 1000);

      const fullTimeDisplay = `${selfPickDate} ${selfPickTime}`;

      // 如果当前时间早于最早允许时间（提早超过2小时）
      if (now < earliestAllowedTime) {
        const confirmed = confirm(
          `是否确定要发送到厨房？\n\n${appointmentLabel}时间为：${fullTimeDisplay}\n\n注意：距离${appointmentLabel}时间还有超过2小时`,
        );
        return confirmed;
      }

      // 如果当前时间晚于结束时间（已过期）
      if (now > endDateTime) {
        const confirmed = confirm(
          `是否确定要发送到厨房？\n\n${appointmentLabel}时间为：${fullTimeDisplay}\n\n注意：此时间已过期`,
        );
        return confirmed;
      }

      // 当前时间在正常范围内：[开始时间-2小时, 结束时间]
      return true;
    } catch (error) {
      console.error('检查预约时间失败:', error);
      showToast('检查预约时间失败，请稍后重试');
      return false;
    }
  };

  const isSpecialTable = (table: OrderTableListItemModel) => {
    const tableTag = table.tableTag || '';
    return ['自提', '外卖', '预定'].some((specialTag) => tableTag.includes(specialTag));
  };

  const closeReservationTableModal = () => {
    if (isChangingReservationTable.value) return;
    reservationTableModalVisible.value = false;
    currentReservationOrder.value = null;
    availableReservationTables.value = [];
    selectedReservationTableId.value = null;
    isLoadingReservationTables.value = false;
  };

  const openReservationTableModal = async (order: OrderListItemModel) => {
    if (!order.shopId) {
      showToast('订单缺少餐厅信息，无法选择桌号');
      return;
    }

    currentReservationOrder.value = order;
    availableReservationTables.value = [];
    selectedReservationTableId.value = null;
    reservationTableModalVisible.value = true;
    isLoadingReservationTables.value = true;

    try {
      const response = await fetchTableList({
        pageNum: 1,
        pageSize: 200,
        data: { shopId: order.shopId },
      });
      if (response.code !== 200) {
        showToast(response.msg || '加载桌位失败');
        return;
      }

      availableReservationTables.value = (response.result.list || []).filter(
        (table) =>
          table.tableStatus === 0 &&
          !table.orderId &&
          Boolean(table.tableId) &&
          !isSpecialTable(table),
      );
    } catch (error) {
      console.error('加载预定订单可用桌位失败:', error);
      showToast('加载桌位失败，请稍后重试');
    } finally {
      isLoadingReservationTables.value = false;
    }
  };

  const confirmReservationTable = async () => {
    const order = currentReservationOrder.value;
    const tableId = selectedReservationTableId.value;
    if (!order?.orderId || !tableId || isChangingReservationTable.value) return;

    isChangingReservationTable.value = true;
    try {
      const response = await editOrderTable({
        orderId: order.orderId,
        tableId,
        dineType: 1,
      });
      if (response.code !== 0 && response.code !== 200) {
        showToast(response.msg || '订单转换失败');
        return;
      }

      let auditErrorMessage = '';
      try {
        const auditResponse = await auditOrder({ orderId: order.orderId });
        if (auditResponse.code !== 200) {
          auditErrorMessage = auditResponse.msg || '发送到厨房失败';
        }
      } catch (error) {
        console.error('预定订单发送到厨房失败:', error);
        auditErrorMessage = '网络异常，请稍后重试';
      }

      isChangingReservationTable.value = false;
      closeReservationTableModal();
      if (selectedShopId.value) {
        await fetchOrderList(selectedShopId.value);
      }
      if (auditErrorMessage) {
        showToast(`订单已转为普通订单，但发送到厨房失败：${auditErrorMessage}`);
      } else {
        showToast('订单已转为普通订单并发送到厨房');
      }
    } catch (error) {
      console.error('预定订单转换失败:', error);
      showToast('订单转换失败，请稍后重试');
    } finally {
      isChangingReservationTable.value = false;
    }
  };

  // 新增：发送到厨房（确认订单）
  const sendToKitchen = async (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法发送到厨房');
      return;
    }

    // 检查自提时间，如果需要确认但用户取消，则直接返回
    if (!checkSelfPickupTime(order)) {
      return;
    }

    if (isReservationOrder(order)) {
      await openReservationTableModal(order);
      return;
    }

    try {
      const response = await auditOrder({ orderId: order.orderId });
      if (response.code === 200) {
        showToast(`订单 #${order.orderNo} 已发送到厨房！`);
        // 刷新订单列表
        if (selectedShopId.value) {
          await fetchOrderList(selectedShopId.value as number);
        }
      } else {
        showToast(response.msg || '发送到厨房失败');
      }
    } catch (error) {
      console.error('发送到厨房失败:', error);
      showToast('发送到厨房失败，请稍后重试');
    }
  };

  // 新增：格式化自提时间显示
  const formatSelfPickupTime = (order: OrderListItemModel) => {
    const date = order.selfPickDate || '';
    const time = order.selfPickTime || '';
    if (!date && !time) return '';

    // 检查是否是今天
    if (date) {
      const today = new Date();
      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(today.getDate()).padStart(2, '0')}`;

      if (date === todayStr) {
        // 如果是今天，显示"今天"
        return time ? `今天 ${time}` : '今天';
      }
    }

    // 不是今天，正常显示日期
    if (date && time) return `${date} ${time}`;
    if (date) return date;
    if (time) return time;
    return '';
  };

  const toggleFilterMenu = () => {
    showFilterMenu.value = !showFilterMenu.value;
    showNavMenu.value = false; // 关闭导航菜单
  };

  const toggleNavMenu = () => {
    showNavMenu.value = !showNavMenu.value;
    showFilterMenu.value = false; // 关闭筛选菜单
  };

  const isFilterTypeSelected = (filter: OrderTypeFilter): boolean => {
    return selectedFilterTypes.value.includes(filter);
  };

  const toggleFilterType = (filter: OrderTypeFilter) => {
    if (isFilterTypeSelected(filter)) {
      selectedFilterTypes.value = selectedFilterTypes.value.filter(
        (selectedFilter) => selectedFilter !== filter,
      );
      return;
    }

    selectedFilterTypes.value = [...selectedFilterTypes.value, filter];
  };

  const toggleAllFilterTypes = () => {
    selectedFilterTypes.value = isAllFilterTypesSelected.value
      ? []
      : orderTypeFilterOptions.map((option) => option.value);
  };

  const refreshOrders = async () => {
    if (selectedShopId.value) {
      await fetchOrderList(selectedShopId.value as number);
      showToast('订单已刷新');
    }
  };

  // 新增：排除未支付开关变化时，重新拉取订单
  const onExcludeUnPaidChange = async () => {
    if (selectedShopId.value) {
      await fetchOrderList(selectedShopId.value as number);
      updateRefreshTime();
    }
  };

  // 新增：更新刷新时间
  const updateRefreshTime = () => {
    const now = new Date();
    currentTimeMs.value = now.getTime();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    lastRefreshTime.value = `${hours}:${minutes}:${seconds}`;
  };

  // 新增：启动自动刷新定时器
  const startAutoRefresh = () => {
    // 清除现有定时器
    if (autoRefreshTimer) {
      clearInterval(autoRefreshTimer);
    }

    // 设置10秒定时器
    autoRefreshTimer = setInterval(async () => {
      if (selectedShopId.value !== null) {
        await fetchOrderList(selectedShopId.value as number);
        updateRefreshTime();
        console.log('自动刷新完成:', lastRefreshTime.value);
      }
    }, 10000); // 10秒
  };

  // 新增：停止自动刷新定时器
  const stopAutoRefresh = () => {
    if (autoRefreshTimer) {
      clearInterval(autoRefreshTimer);
      autoRefreshTimer = null;
    }
  };

  // 新增：判断是否可以显示确认支付完成按钮
  const isOrderPaid = (order: Pick<OrderListItemModel, 'paymentStatus' | 'paymentStatusName'>) => {
    if (order.paymentStatus === 10) return true;

    const statusLower = order.paymentStatusName?.toLowerCase() || '';
    return (
      statusLower.includes('已支付') ||
      statusLower.includes('支付成功') ||
      statusLower.includes('paid') ||
      statusLower.includes('success')
    );
  };

  const canShowConfirmPayment = (order: OrderListItemModel) => {
    // 如果订单已取消，不能确认支付
    if (order.orderStatus === 999) {
      return false;
    }

    if (isOrderPaid(order)) {
      return false;
    }

    const payableAmount = order.remainAmount ?? order.totalAmount ?? 0;
    return payableAmount > 0;
  };

  // 新增：加载店铺详情并判断支付方式
  const loadShopDetail = async (shopId: number) => {
    try {
      const response = await fetchShopDetail({ shopId: shopId });
      if (response.code === 200) {
        // 判断支付方式：0线下、1线上
        isOnlinePayment.value = response.result.paymentLine === 1;
        // 如果有B扫C收款选项，默认选择B扫C收款
        if (isOnlinePayment.value) {
          selectedPaymentMethod.value = 3;
        }
      }
    } catch (error) {
      console.error('加载店铺详情失败:', error);
    }
  };

  // 新增：显示支付确认模态框
  const showPaymentConfirmModal = async (order: any) => {
    // 保存当前订单信息到本地状态，供确认支付时使用
    currentPaymentOrder.value = order;

    // 加载店铺详情以判断支付方式
    if (order.shopId) {
      await loadShopDetail(order.shopId);
    }

    // 如果有B扫C收款选项，默认选择B扫C收款，否则选择POS支付
    selectedPaymentMethod.value = isOnlinePayment.value ? 3 : 4;
    paymentRemark.value = '';
    paymentConfirmModalVisible.value = true;
  };

  // 新增：隐藏支付确认模态框
  const hidePaymentConfirmModal = () => {
    paymentConfirmModalVisible.value = false;
    isConfirmingPayment.value = false;
    // 如果有B扫C收款选项，默认选择B扫C收款，否则选择POS支付
    selectedPaymentMethod.value = isOnlinePayment.value ? 3 : 4;
    paymentRemark.value = '';
    currentPaymentOrder.value = null;
  };

  // 处理支付确认（根据支付方式选择不同的处理逻辑）
  const handlePaymentConfirm = () => {
    if (selectedPaymentMethod.value === 3) {
      // B扫C收款，显示扫码界面
      paymentConfirmModalVisible.value = false;
      isConfirmingPayment.value = false;
      paymentRemark.value = '';
      showScanPaymentModal();
    } else {
      // 其他支付方式，直接确认支付
      confirmPayment();
    }
  };

  const isPaymentPrintFailure = (message?: string): boolean => {
    if (!message) return false;
    return /打印|打印机|小票/.test(message);
  };

  const getPaymentErrorMessage = (error: unknown): string => {
    if (error instanceof Error && isPaymentPrintFailure(error.message)) {
      return error.message;
    }

    if (typeof error !== 'object' || error === null || !('response' in error)) {
      return '';
    }

    const response = (error as { response?: { data?: { msg?: unknown } } }).response;
    return typeof response?.data?.msg === 'string' ? response.data.msg : '';
  };

  const refreshOrderListAfterPayment = async () => {
    if (!selectedShopId.value) return;

    try {
      await fetchOrderList(selectedShopId.value as number);
    } catch (error) {
      console.error('支付完成后刷新订单列表失败:', error);
    }
  };

  const verifyOrderPaid = async (orderId: number): Promise<boolean | null> => {
    try {
      const response = await getOrder({ orderId });
      if (response.code !== 200 || !response.result) return null;
      return isOrderPaid(response.result);
    } catch (error) {
      console.error('核验订单支付状态失败:', error);
      return null;
    }
  };

  const handlePaymentSubmissionError = async (
    orderId: number,
    errorMessage: string,
  ): Promise<void> => {
    const paymentConfirmed = await verifyOrderPaid(orderId);

    if (paymentConfirmed === true) {
      hidePaymentConfirmModal();
      showToast('支付已成功，但打印失败，请稍后补打小票');
      await refreshOrderListAfterPayment();
      return;
    }

    if (paymentConfirmed === null) {
      hidePaymentConfirmModal();
      showToast('支付结果暂时无法确认，请刷新订单状态后再操作');
      return;
    }

    showToast(errorMessage || '确认支付失败');
  };

  // 新增：确认支付
  const confirmPayment = async () => {
    if (isConfirmingPayment.value) return;

    const currentOrder = currentPaymentOrder.value;
    if (!currentOrder || !currentOrder.orderId) {
      showToast('订单信息不完整，无法确认支付');
      return;
    }

    isConfirmingPayment.value = true;

    try {
      // 获取工号
      const employeeId = getEmployeeId();
      const employeeName = getEmployeeName();

      let remark = '';
      let paymentMethodName = '';

      // 根据选择的支付方式设置备注和支付方式名称
      if (selectedPaymentMethod.value === 3) {
        paymentMethodName = 'B扫C收款';
        remark = `服务员${employeeName}确认B扫C收款完成，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 4) {
        paymentMethodName = 'POS支付';
        remark = `服务员${employeeName}确认POS支付完成，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 5) {
        paymentMethodName = '公司挂账';
        remark = `服务员${employeeName}确认挂账，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 7) {
        paymentMethodName = '现金支付';
        remark = `服务员${employeeName}确认现金支付完成，${paymentRemark.value || ''}`;
      }

      // 构建支付数据
      const paymentData = {
        orderId: currentOrder.orderId,
        paymentMethod: selectedPaymentMethod.value,
        paymentMethodName: paymentMethodName,
        paymentStatus: 1, // 已支付
        amount: currentOrder.remainAmount ?? currentOrder.totalAmount ?? 0,
        paymentTime: dateTimeFormat(dayjs()),
        remark: remark.trim(),
      };

      // 调用支付确认接口
      const response = await insertOrderPayment(paymentData);
      if (response.code === 200) {
        hidePaymentConfirmModal();
        showToast(`${currentOrder.tableName}号桌${paymentMethodName}已确认完成！`);
        await refreshOrderListAfterPayment();
      } else if (isPaymentPrintFailure(response.msg)) {
        await handlePaymentSubmissionError(currentOrder.orderId, response.msg);
      } else {
        showToast(response.msg || '确认支付失败');
      }
    } catch (error) {
      console.error('确认支付失败:', error);
      const errorMessage = getPaymentErrorMessage(error);
      if (isPaymentPrintFailure(errorMessage)) {
        await handlePaymentSubmissionError(currentOrder.orderId, errorMessage);
      } else {
        showToast('确认支付失败，请稍后重试');
      }
    } finally {
      isConfirmingPayment.value = false;
    }
  };

  // 从登录态获取工号
  const getEmployeeId = () => {
    return employeeId.value;
  };

  // 从登录态获取员工姓名
  const getEmployeeName = () => {
    return employeeName.value;
  };

  const showToast = (message: string) => {
    // 创建提示框
    const toast = document.createElement('div');
    toast.className =
      'fixed top-4 right-4 bg-gray-900 text-white px-4 py-2 rounded-lg z-50 transform translate-x-full transition-transform duration-300';
    toast.textContent = message;
    document.body.appendChild(toast);

    // 显示动画
    setTimeout(() => {
      toast.classList.remove('translate-x-full');
    }, 100);

    // 自动隐藏
    setTimeout(() => {
      toast.classList.add('translate-x-full');
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 2000);
  };

  // 原有的接口调用逻辑
  // const foodOut = async (shopId: number, orderId: number, orderFoodId: number) => {
  //   return await outFood({
  //     orderId: orderId,
  //     orderFoodId: orderFoodId,
  //     shopId: shopId,
  //   });
  // };

  const fetchOrderList = async (shopId: number) => {
    const requestData: any = {
      shopId: shopId,
      orderStatuss: [1, 2, 8],
      sortType: 2,
    };

    // 如果勾选“排除未支付”，增加支付状态筛选条件（仅查询已支付，例如状态10）
    if (excludeUnPaid.value) {
      requestData.paymentStatuss = [10];
    }

    const respOrder = await getOrderList({
      pageNum: 1,
      pageSize: 999,
      data: requestData,
    });
    if (respOrder.code === 200) {
      const list = respOrder.result.list || [];
      // list[0].dineType = 2;
      orderList.value = list.map((order) => ({
        ...order,
        foodList: [...(order.foodList || [])].sort(
          (a, b) =>
            (a.orderFoodId ?? Number.MAX_SAFE_INTEGER) - (b.orderFoodId ?? Number.MAX_SAFE_INTEGER),
        ),
      }));

      // 新增：记录最后一项创建时间并与上次记录对比，提示新订单
      if (list.length > 0) {
        const last = list[list.length - 1];
        const lastCreateMs = new Date((last as any).createTime || '').getTime();
        if (!Number.isNaN(lastCreateMs)) {
          const prev = getStoredLastCreateTime(shopId);
          if (prev !== null && lastCreateMs > prev) {
            showToast('您有新的订单，请注意查收');
            playNewOrderSound();
          }
          setStoredLastCreateTime(shopId, lastCreateMs);
        }
      }
    }
  };

  const onShopChange = async () => {
    if (selectedShopId.value !== null) {
      // 保存选中的餐厅到localStorage
      saveSelectedShop(selectedShopId.value as number);
      await fetchOrderList(selectedShopId.value as number);
    }
  };

  const removeOrder = (orderId: number) => {
    const idx = orderList.value.findIndex((o) => o.orderId === orderId);
    if (idx !== -1) orderList.value.splice(idx, 1);
  };

  // 从接口返回中安全获取订单状态
  const getOrderStatusFromResp = (resp: any): number | null => {
    if (!resp) return null;
    if (typeof resp.orderStatus === 'number') return resp.orderStatus;
    if (resp.result && typeof resp.result.orderStatus === 'number') return resp.result.orderStatus;
    return null;
  };

  const handleFoodOut = async (order: any, item: any) => {
    if (item.status === 9 || isFoodCancelled(item)) return;
    console.log('item:', item);
    console.log(
      'orderId:',
      order.orderId,
      'orderFoodId:',
      item.orderFoodId,
      'shopId:',
      order.shopId,
    );
    const resp: any = await foodUp({
      orderId: order.orderId,
      orderFoodId: item.orderFoodId,
      shopId: order.shopId,
    });
    if (resp.code === 200) {
      const idx = order.foodList.findIndex((f: any) => f.orderFoodId === item.orderFoodId);
      if (idx !== -1) {
        order.foodList[idx] = { ...order.foodList[idx], status: 9 }; // 更新为已上菜状态
      }

      // 根据接口返回的订单状态决定是否移除订单
      const orderStatus = getOrderStatusFromResp(resp);
      if (orderStatus === 10) {
        setTimeout(() => {
          removeOrder(order.orderId);
        }, 300);
      }
    }
  };

  // 新增：判断订单是否全部出餐
  const isOrderAllCompleted = (order: OrderListItemModel): boolean => {
    const activeFoods = getActiveFoods(order);
    return activeFoods.length > 0 && activeFoods.every((item) => item.status === 9);
  };

  // 新增：核销按钮点击，调用订单完成接口
  const handleVerify = async (order: any) => {
    if (!order?.orderId) {
      console.warn('核销失败：缺少订单ID');
      return;
    }
    try {
      const resp = await completeOrder({ orderId: order.orderId });
      if (resp.code === 200) {
        // 接口成功后，从列表中移除该订单
        removeOrder(order.orderId);
      } else {
        console.warn('核销失败:', resp.msg || '接口返回错误');
      }
    } catch (e) {
      console.error('核销异常:', e);
    }
  };

  const completeAllFood = async (orderId: number, shopId: number) => {
    return await foodUp({
      orderId: orderId,
      shopId: shopId,
    });
  };

  const handleCompleteAll = async (order: any) => {
    if (getActiveFoods(order).length === 0) return;
    const resp: any = await completeAllFood(order.orderId, order.shopId);
    if (resp.code === 200) {
      // 标记所有菜品为已出餐
      if (order.foodList) {
        order.foodList.forEach((item: FoodList) => {
          if (!isFoodCancelled(item)) item.status = 9;
        });
      }

      // 根据接口返回的订单状态决定是否移除订单
      const orderStatus = getOrderStatusFromResp(resp);
      if (orderStatus === 10) {
        setTimeout(() => {
          removeOrder(order.orderId);
        }, 300);
      }
    }
  };

  const goToDishAssignment = () => {
    router.push('/dishAssignment');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToKitchenOrder = () => {
    router.push('/kitchenOrder');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToHistory = () => {
    router.push('/servingHistory');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToOrderHistory = () => {
    router.push('/orderHistory');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToTableManage = () => {
    router.push('/tableManage');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToFoodManage = () => {
    router.push('/foodManage');
    showNavMenu.value = false; // 关闭菜单
  };

  // 点击外部关闭菜单
  const handleClickOutside = (event: Event) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.filter-dropdown')) {
      showFilterMenu.value = false;
    }
    if (!target.closest('.nav-dropdown')) {
      showNavMenu.value = false;
    }
  };

  onMounted(async () => {
    const respShop = await fetchShopList({ pageNum: 1, pageSize: 100, data: { shopStatus: 0 } });
    if (respShop.code === 200 && respShop.result.list.length > 0) {
      shopList.value = respShop.result.list;
      const savedShopId = loadSelectedShop();
      if (savedShopId && isValidShop(savedShopId)) {
        selectedShopId.value = savedShopId;
      } else {
        selectedShopId.value = shopList.value[0].shopId;
        // 确保selectedShopId.value不为null时再保存
        if (selectedShopId.value !== null) {
          saveSelectedShop(selectedShopId.value as number);
        }
      }
      // 确保selectedShopId.value不为null时再加载订单
      if (selectedShopId.value !== null) {
        await fetchOrderList(selectedShopId.value as number);
      }

      // 新增：初始化刷新时间并启动自动刷新
      updateRefreshTime();
      startAutoRefresh();
      // 新增：初始化新订单提示音
      initNewOrderAudio();
    }

    document.addEventListener('click', handleClickOutside);
  });

  onUnmounted(() => {
    clearQuickFind();
    document.removeEventListener('click', handleClickOutside);
    // 新增：组件卸载时清理定时器
    stopAutoRefresh();
    newOrderAudio = null;
    // 清理扫码资源
    stopScan();
  });

  // 显示扫码支付全屏界面
  const showScanPaymentModal = async () => {
    scanPaymentModalVisible.value = true;
    scanPaymentRemark.value = '';
    scanStatus.value = '';
    // 立即设置为扫描中，避免显示"正在启动摄像头"提示
    isScanning.value = true;

    // 自动开始扫描
    await nextTick();
    getCamerasInfo();
  };

  // 隐藏扫码支付全屏界面
  const hideScanPaymentModal = () => {
    stopScan();
    scanPaymentModalVisible.value = false;
    isSubmittingScanPayment.value = false;
    scanPaymentRemark.value = '';
    scanStatus.value = '';
  };

  // 获取摄像头信息并初始化
  const getCamerasInfo = () => {
    // 立即设置为扫描中，隐藏"正在启动摄像头"提示
    isScanning.value = true;

    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices && devices.length) {
          html5QrCode = new Html5Qrcode('qr-reader');
          startScan();
        } else {
          // 没有可用摄像头
          isScanning.value = false;
          scanStatus.value = '未检测到摄像头设备';
          scanStatusClass.value = 'bg-red-100 text-red-700';
        }
      })
      .catch((err) => {
        console.error('获取摄像头失败:', err);
        scanStatus.value = '摄像头无访问权限！';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        isScanning.value = false;
      });
  };

  // 开始扫描
  const startScan = () => {
    if (!html5QrCode) {
      console.error('html5QrCode 未初始化');
      return;
    }

    isScanning.value = true;
    scanStatus.value = '';
    scanStatusClass.value = '';

    html5QrCode
      .start(
        { facingMode: 'environment' },
        {
          fps: 20,
          // 全屏扫码：使用整个视窗大小
          qrbox: function (viewfinderWidth, viewfinderHeight) {
            return {
              width: viewfinderWidth,
              height: viewfinderHeight,
            };
          },
          // 不限制宽高比，允许全屏显示
          aspectRatio: undefined,
        },
        (decodedText, decodedResult) => {
          // 扫码成功回调
          handleScanResult(decodedText);
        },
      )
      .then(() => {
        // 扫描启动成功后，强制应用全屏样式
        nextTick(() => {
          forceFullscreenStyles();
        });
      })
      .catch((err) => {
        console.error('扫码失败', err);
        scanStatus.value = '启动摄像头失败，请检查权限设置';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        isScanning.value = false;
      });
  };

  // 强制应用全屏样式
  const forceFullscreenStyles = () => {
    const qrReader = document.getElementById('qr-reader');
    if (!qrReader) return;

    // 强制设置容器样式
    const container = qrReader.querySelector('#html5qr-container');
    if (container) {
      (container as HTMLElement).style.width = '100%';
      (container as HTMLElement).style.height = '100%';
      (container as HTMLElement).style.minWidth = '100%';
      (container as HTMLElement).style.minHeight = '100%';
    }

    // 强制设置视频样式
    const videos = qrReader.querySelectorAll('video');
    videos.forEach((video) => {
      video.style.width = '100%';
      video.style.height = '100%';
      video.style.minWidth = '100%';
      video.style.minHeight = '100%';
      video.style.objectFit = 'cover';
      video.style.position = 'absolute';
      video.style.top = '0';
      video.style.left = '0';
      video.style.right = '0';
      video.style.bottom = '0';
    });

    // 强制设置画布样式
    const canvases = qrReader.querySelectorAll('canvas');
    canvases.forEach((canvas) => {
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.style.minWidth = '100%';
      canvas.style.minHeight = '100%';
      canvas.style.objectFit = 'cover';
      canvas.style.position = 'absolute';
      canvas.style.top = '0';
      canvas.style.left = '0';
      canvas.style.right = '0';
      canvas.style.bottom = '0';
    });
  };

  // 停止扫描
  const stopScan = async (): Promise<void> => {
    if (html5QrCode && html5QrCode.isScanning) {
      try {
        await html5QrCode.stop();
        html5QrCode.clear();
      } catch (error) {
        console.error('停止扫描失败:', error);
      }
    }
    isScanning.value = false;
  };

  // 处理扫描结果
  const handleScanResult = async (scanCode: string) => {
    // 验证扫码结果
    if (!scanCode || scanCode.trim() === '' || isSubmittingScanPayment.value) {
      return;
    }

    isSubmittingScanPayment.value = true;

    try {
      // 停止扫描，但保持界面打开
      await stopScan();

      // 显示处理中状态
      scanStatus.value = '扫码成功，正在处理支付...';
      scanStatusClass.value = 'bg-blue-100 text-blue-700';

      // 调用支付接口
      await submitScanPayment(scanCode);
    } finally {
      isSubmittingScanPayment.value = false;
    }
  };

  // 提交扫码支付
  const submitScanPayment = async (scanCode: string) => {
    try {
      const currentOrder = currentPaymentOrder.value;
      if (!currentOrder || !currentOrder.orderId) {
        scanStatus.value = '订单信息不完整，无法支付';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        showToast('订单信息不完整，无法支付');
        return;
      }

      // 获取IP地址（简化处理，实际可以从服务器获取）
      const ip = await getClientIP();

      // 构建支付数据
      const paymentData = {
        orderId: currentOrder.orderId,
        scanCode: scanCode,
        remark: scanPaymentRemark.value || '',
        ip: ip || '',
        amount: currentOrder.remainAmount ?? currentOrder.totalAmount ?? 0,
      };

      // 调用扫码支付接口
      const response = await scanPayment(paymentData);

      // 根据接口返回结果处理
      if (response.code === 200) {
        // API 返回 200，立即关闭扫码界面
        hideScanPaymentModal();

        // 根据业务结果在详情界面显示提示
        if (response.result?.success) {
          // 支付成功
          showToast('扫码支付成功！');
          // 刷新订单列表
          if (selectedShopId.value) {
            await fetchOrderList(selectedShopId.value as number);
          }
        } else {
          // 支付失败，显示确认模态框
          scanPaymentFailErrorMsg.value = response.result?.errorMsg || '';
          scanPaymentFailModalVisible.value = true;
        }
      } else {
        // API 返回非 200，支付结果可能不明确，交由服务员选择查询或重新扫码
        const errorMsg = response.msg || '支付失败，请重试';
        hideScanPaymentModal();
        scanPaymentFailErrorMsg.value = errorMsg;
        scanPaymentFailModalVisible.value = true;
      }
    } catch (error) {
      console.error('扫码支付失败:', error);

      // 网络异常时支付结果也可能不明确，交由服务员选择查询或重新扫码
      hideScanPaymentModal();
      scanPaymentFailErrorMsg.value = '支付失败，请稍后重试';
      scanPaymentFailModalVisible.value = true;
    }
  };

  // 获取客户端IP地址（简化版本）
  const getClientIP = async (): Promise<string> => {
    // 可以调用后端接口获取真实IP，这里先返回空字符串
    // 或者使用第三方服务获取IP
    return '';
  };

  // 确认已经支付（刷新扫码支付状态）
  const confirmScanPaymentPaid = async () => {
    // 防抖：如果正在刷新，直接返回
    if (isRefreshingPayment.value) {
      return;
    }

    try {
      const currentOrder = currentPaymentOrder.value;
      if (!currentOrder || !currentOrder.orderId) {
        showToast('订单信息不完整，无法确认支付');
        return;
      }

      // 设置 loading 状态
      isRefreshingPayment.value = true;

      const response = await refreshScanPayment({
        orderId: currentOrder.orderId,
      });

      if (response.code === 200) {
        // 根据业务结果处理
        if (response.result?.success) {
          // 支付成功，关闭模态框
          scanPaymentFailModalVisible.value = false;
          scanPaymentFailErrorMsg.value = '';
          showToast('支付成功！');
          // 刷新订单列表
          if (selectedShopId.value) {
            await fetchOrderList(selectedShopId.value as number);
          }
        } else {
          // 支付失败，显示错误信息，模态框不关闭
          const errorMsg = response.result?.errorMsg || '刷新支付状态失败，请重试';
          scanPaymentFailErrorMsg.value = errorMsg;
          showToast(errorMsg);
        }
      } else {
        // API 返回非 200，显示错误信息，模态框不关闭
        const errorMsg = response.msg || '刷新支付状态失败，请稍后重试';
        scanPaymentFailErrorMsg.value = errorMsg;
        showToast(errorMsg);
      }
    } catch (error) {
      console.error('刷新支付状态失败:', error);
      const errorMsg = '刷新支付状态失败，请稍后重试';
      scanPaymentFailErrorMsg.value = errorMsg;
      showToast(errorMsg);
    } finally {
      // 无论成功失败，都要重置 loading 状态
      isRefreshingPayment.value = false;
    }
  };

  // 确认未支付后重新扫码，重新发起扫码支付
  const retryScanPayment = async () => {
    scanPaymentFailModalVisible.value = false;
    scanPaymentFailErrorMsg.value = '';
    await showScanPaymentModal();
  };

  // 取消确认支付
  const cancelScanPaymentConfirm = () => {
    scanPaymentFailModalVisible.value = false;
    scanPaymentFailErrorMsg.value = '';
    isRefreshingPayment.value = false; // 重置 loading 状态
  };

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "contentContainerRef",
    ref: contentContainerRef,
    class: "content-container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "summary-info" }, [
          _createElementVNode("span", {
            id: "summary-badge",
            class: "summary-badge urgent"
          }, " 订单出餐 ")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedShopId).value = $event)),
            class: "restaurant-dropdown",
            disabled: "",
            onChange: onShopChange
          }, [
            (shopList.value.length === 0)
              ? (_openBlock(), _createElementBlock("option", _hoisted_4, "加载中..."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
              return (_openBlock(), _createElementBlock("option", {
                key: shop.shopId,
                value: shop.shopId
              }, _toDisplayString(shop.shopName), 9, _hoisted_5))
            }), 128))
          ], 544), [
            [_vModelSelect, selectedShopId.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-clock mr-2" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(lastRefreshTime.value || '未刷新'), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_a_switch, {
              checked: excludeUnPaid.value,
              "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((excludeUnPaid).value = $event)),
              onChange: onExcludeUnPaidChange
            }, null, 8, ["checked"]),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "exclude-paid-label" }, "排除未支付", -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_a_switch, {
              checked: onlyToday.value,
              "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((onlyToday).value = $event))
            }, null, 8, ["checked"]),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "order-filter-label" }, "只看今天", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "quick-find-btn",
          onClick: openQuickFind
        }, _cache[17] || (_cache[17] = [
          _createElementVNode("i", { class: "fas fa-search" }, null, -1),
          _createTextVNode(" 快速查找 ", -1)
        ])),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "nav-menu-btn",
            onClick: toggleNavMenu
          }, _cache[18] || (_cache[18] = [
            _createElementVNode("i", { class: "fas fa-bars" }, null, -1),
            _createTextVNode(" 菜单 ", -1),
            _createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1)
          ])),
          _createElementVNode("div", {
            class: _normalizeClass(["nav-menu", { show: showNavMenu.value }])
          }, [
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToTableManage
            }, _cache[19] || (_cache[19] = [
              _createElementVNode("i", { class: "fas fa-table" }, null, -1),
              _createTextVNode(" 桌位管理 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToKitchenOrder
            }, _cache[20] || (_cache[20] = [
              _createElementVNode("i", { class: "fas fa-utensils" }, null, -1),
              _createTextVNode(" 订单出餐 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToOrderHistory
            }, _cache[21] || (_cache[21] = [
              _createElementVNode("i", { class: "fas fa-receipt" }, null, -1),
              _createTextVNode(" 订单查询 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToDishAssignment
            }, _cache[22] || (_cache[22] = [
              _createElementVNode("i", { class: "fas fa-tasks" }, null, -1),
              _createTextVNode(" 菜品分配 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToHistory
            }, _cache[23] || (_cache[23] = [
              _createElementVNode("i", { class: "fas fa-history" }, null, -1),
              _createTextVNode(" 出餐历史 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToFoodManage
            }, _cache[24] || (_cache[24] = [
              _createElementVNode("i", { class: "fas fa-utensils" }, null, -1),
              _createTextVNode(" 菜品管理 ", -1)
            ]))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: _normalizeClass(["filter-btn", { active: !isAllFilterTypesSelected.value }]),
            onClick: toggleFilterMenu
          }, [
            _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fas fa-filter" }, null, -1)),
            _cache[26] || (_cache[26] = _createTextVNode(" 筛选 ", -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString(filterButtonText.value), 1),
            _createElementVNode("i", {
              class: _normalizeClass(["fas fa-chevron-down", { rotated: showFilterMenu.value }])
            }, null, 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["filter-menu", { show: showFilterMenu.value }])
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[27] || (_cache[27] = _createElementVNode("span", null, "订单类型", -1)),
                _createElementVNode("span", null, "已选 " + _toDisplayString(selectedFilterTypes.value.length) + " 项", 1)
              ]),
              _createElementVNode("button", {
                class: _normalizeClass(["filter-menu-item", { active: isAllFilterTypesSelected.value }]),
                onClick: toggleAllFilterTypes
              }, [
                _cache[28] || (_cache[28] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fas fa-list" }),
                  _createTextVNode("全部订单")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["filter-check fas", isAllFilterTypesSelected.value ? 'fa-check-square' : 'fa-square'])
                }, null, 2)
              ], 2),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orderTypeFilterOptions, (option) => {
                return _createElementVNode("button", {
                  key: option.value,
                  class: _normalizeClass(["filter-menu-item", { active: isFilterTypeSelected(option.value) }]),
                  onClick: ($event: any) => (toggleFilterType(option.value))
                }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas", option.icon])
                    }, null, 2),
                    _createTextVNode(_toDisplayString(option.label), 1)
                  ]),
                  _createElementVNode("i", {
                    class: _normalizeClass(["filter-check fas", isFilterTypeSelected(option.value) ? 'fa-check-square' : 'fa-square'])
                  }, null, 2)
                ], 10, _hoisted_15)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "filter-done-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showFilterMenu.value = false))
              }, "完成")
            ])
          ], 2)
        ]),
        _createElementVNode("button", {
          class: "refresh-btn",
          onClick: refreshOrders
        }, _cache[29] || (_cache[29] = [
          _createElementVNode("i", { class: "fas fa-sync-alt" }, null, -1),
          _createTextVNode(" 刷新 ", -1)
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        (filteredOrderList.value.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(filteredOrderList.value, (order) => {
              return (_openBlock(), _createElementBlock("div", {
                key: order.orderId,
                class: _normalizeClass(["order-card", { 'quick-find-highlight': highlightedOrderId.value === order.orderId }]),
                "data-order-id": order.orderId
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["order-header", {
                'takeaway-header': order.dineType === 2,
                'delivery-header': order.dineType === 3,
                'reservation-header': order.dineType === 5,
              }])
                }, [
                  (shouldShowAppointmentTime(order))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (shouldShowSendToKitchen(order))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "send-to-kitchen-btn",
                              onClick: ($event: any) => (sendToKitchen(order))
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["fas mr-2", isReservationOrder(order) ? 'fa-chair' : 'fa-paper-plane'])
                              }, null, 2),
                              _createTextVNode(_toDisplayString(isReservationOrder(order) ? '确定桌号' : '发送到厨房'), 1)
                            ], 8, _hoisted_21))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_22, [
                          _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fas fa-clock mr-2" }, null, -1)),
                          _createTextVNode(_toDisplayString(getAppointmentTimeLabel(order)) + "：" + _toDisplayString(formatSelfPickupTime(order) || '待确认'), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createTextVNode(_toDisplayString(order.shopName), 1),
                      (getDisplayPickCode(order))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, " - 取餐码：" + _toDisplayString(getDisplayPickCode(order)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["order-pay-status", {
                    unpaid:
                      order.paymentStatusName &&
                      (order.paymentStatusName.includes('未') ||
                        order.paymentStatusName.includes('待')),
                    paid:
                      order.paymentStatusName &&
                      (order.paymentStatusName.includes('已支付') ||
                        order.paymentStatusName.includes('支付成功') ||
                        order.paymentStatusName.includes('paid') ||
                        order.paymentStatusName.includes('success')),
                  }])
                    }, _toDisplayString(order.paymentStatusName || '未知'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(formatDateTime(order.createTime)), 1),
                      (getElapsedMinutes(order.createTime) !== null)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["order-elapsed-time", getElapsedTimeClass(order.createTime)]),
                            "aria-label": `已创建${getElapsedMinutes(order.createTime)}分钟`
                          }, [
                            _cache[31] || (_cache[31] = _createElementVNode("i", {
                              class: "fas fa-clock mr-1",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createTextVNode(_toDisplayString(getElapsedMinutes(order.createTime)), 1)
                          ], 10, _hoisted_29))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_30, "¥" + _toDisplayString((order.totalAmount || 0).toFixed(2)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", {
                        class: "order-id",
                        role: "button",
                        tabindex: "0",
                        "aria-label": "查看订单详情",
                        onClick: _withModifiers(($event: any) => (openOrderDetails(order)), ["stop"]),
                        onKeydown: [
                          _withKeys(_withModifiers(($event: any) => (openOrderDetails(order)), ["prevent"]), ["enter"]),
                          _withKeys(_withModifiers(($event: any) => (openOrderDetails(order)), ["prevent"]), ["space"])
                        ]
                      }, [
                        _createElementVNode("span", _hoisted_34, " 订单号： " + _toDisplayString(getOrderNoPrefix(order.orderNo)), 1),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(getOrderNoSuffix(order.orderNo)), 1)
                      ], 40, _hoisted_33),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createTextVNode(_toDisplayString(order.tableName) + " ", 1),
                          (getDineTypeText(order))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["order-type-badge", getDineTypeClass(order)])
                              }, _toDisplayString(getDineTypeText(order)), 3))
                            : _createCommentVNode("", true)
                        ]),
                        (Number(order.orderType) === 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "seat-number-btn",
                              title: order.seatNumber ? '修改座位号' : '添加座位号',
                              onClick: ($event: any) => (openSeatNumberModal(order))
                            }, [
                              _cache[32] || (_cache[32] = _createElementVNode("i", { class: "fas fa-chair mr-1" }, null, -1)),
                              _createTextVNode(_toDisplayString(order.seatNumber || '添加座位号'), 1)
                            ], 8, _hoisted_38))
                          : _createCommentVNode("", true)
                      ]),
                      (isReservationOrder(order))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _cache[33] || (_cache[33] = _createElementVNode("i", { class: "fas fa-users mr-1" }, null, -1)),
                            _createTextVNode("预定人数：" + _toDisplayString(order.personCount ?? 0) + "人 ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (isDeliveryOrder(order))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _cache[34] || (_cache[34] = _createElementVNode("i", { class: "fas fa-map-marker-alt mr-1" }, null, -1)),
                            _createTextVNode(_toDisplayString(order.consigneeAddress || '待填写地址'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (order.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fas fa-sticky-note mr-1" }, null, -1)),
                            _createTextVNode(_toDisplayString(order.description), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      (canShowConfirmPayment(order))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "confirm-payment-btn",
                            title: "确认支付完成",
                            onClick: ($event: any) => (showPaymentConfirmModal(order))
                          }, _cache[36] || (_cache[36] = [
                            _createElementVNode("i", { class: "fas fa-credit-card mr-2" }, null, -1),
                            _createTextVNode("确认支付 ", -1)
                          ]), 8, _hoisted_43))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_44, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.foodList || [], (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.orderFoodId,
                      class: _normalizeClass(["order-item", { 'order-item-cancelled': isFoodCancelled(item) }])
                    }, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, _toDisplayString(foodDisplayName(item)), 1),
                          (item.foodCookDesc && item.foodCookDesc.trim() !== '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fas fa-utensils mr-1" }, null, -1)),
                                _createTextVNode(_toDisplayString(item.foodCookDesc), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_49, "×" + _toDisplayString(item.quantity), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "item-btn",
                        disabled: item.status === 9 || isFoodCancelled(item),
                        style: _normalizeStyle({ backgroundColor: item.status === 9 ? '#34C759' : '' }),
                        onClick: ($event: any) => (handleFoodOut(order, item))
                      }, _toDisplayString(isFoodCancelled(item) ? '已取消' : item.status === 9 ? '已出餐' : '出餐'), 13, _hoisted_50)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, _toDisplayString(getOrderStatus(order)), 1),
                  (getActiveFoods(order).length > 0 && !isOrderAllCompleted(order))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "complete-all-btn",
                        onClick: ($event: any) => (handleCompleteAll(order))
                      }, " 全部出餐 ", 8, _hoisted_53))
                    : (isOrderAllCompleted(order))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "complete-all-btn verify-btn",
                          onClick: ($event: any) => (handleVerify(order))
                        }, " 核销 ", 8, _hoisted_54))
                      : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_19))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_55, "暂无订单"))
      ])
    ]),
    _createVNode(_component_van_dialog, {
      show: quickFindVisible.value,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((quickFindVisible).value = $event)),
      title: "按订单尾号查找",
      "show-confirm-button": false,
      onClosed: onQuickFindClosed
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_56, [
          _cache[39] || (_cache[39] = _createElementVNode("span", null, "请输入订单号后四位", -1)),
          _createElementVNode("div", {
            class: "quick-find-digits",
            "aria-label": `已输入${quickFindInput.value.length}位`
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
              return _createElementVNode("span", {
                key: index,
                class: "quick-find-digit"
              }, _toDisplayString(quickFindInput.value[index - 1] || '—'), 1)
            }), 64))
          ], 8, _hoisted_57),
          _createElementVNode("div", _hoisted_58, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (digit) => {
              return _createElementVNode("button", {
                key: digit,
                type: "button",
                onClick: ($event: any) => (appendQuickFindDigit(String(digit)))
              }, _toDisplayString(digit), 9, _hoisted_59)
            }), 64)),
            _createElementVNode("button", {
              type: "button",
              class: "quick-find-key-action",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (quickFindInput.value = ''))
            }, " 清空 "),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (appendQuickFindDigit('0')))
            }, "0"),
            _createElementVNode("button", {
              type: "button",
              class: "quick-find-key-action",
              "aria-label": "删除上一位",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (quickFindInput.value = quickFindInput.value.slice(0, -1)))
            }, _cache[38] || (_cache[38] = [
              _createElementVNode("i", {
                class: "fas fa-backspace",
                "aria-hidden": "true"
              }, null, -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (quickFindVisible.value = false))
            }, "取消")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (seatNumberModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", null, [
                _cache[40] || (_cache[40] = _createElementVNode("h3", { class: "text-xl font-bold" }, "选择座位号", -1)),
                _createElementVNode("p", _hoisted_64, _toDisplayString(currentSeatOrder.value?.tableName || '') + " · " + _toDisplayString(currentSeatOrder.value?.orderNo || ''), 1)
              ]),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700",
                disabled: isEditingSeatNumber.value,
                onClick: closeSeatNumberModal
              }, _cache[41] || (_cache[41] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]), 8, _hoisted_65)
            ]),
            (isLoadingSeatTables.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, _cache[42] || (_cache[42] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                  _createTextVNode("正在加载桌位... ", -1)
                ])))
              : (seatTableList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, " 暂无可选桌位 "))
                : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seatTableList.value, (table) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: table.tableId,
                        class: _normalizeClass(["seat-table-option", { selected: selectedSeatNumber.value === table.tableName }]),
                        disabled: isEditingSeatNumber.value || !table.tableName,
                        onClick: ($event: any) => (selectSeatNumber(table))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(table.tableName || '未命名桌位'), 1),
                        (isEditingSeatNumber.value && selectedSeatNumber.value === table.tableName)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_70))
                          : (selectedSeatNumber.value === table.tableName)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_71))
                            : _createCommentVNode("", true)
                      ], 10, _hoisted_69))
                    }), 128))
                  ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (reservationTableModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _cache[44] || (_cache[44] = _createElementVNode("div", null, [
                _createElementVNode("h3", { class: "text-xl font-bold" }, "选择桌号")
              ], -1)),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700",
                disabled: isChangingReservationTable.value,
                onClick: closeReservationTableModal
              }, _cache[43] || (_cache[43] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]), 8, _hoisted_75)
            ]),
            (isLoadingReservationTables.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, _cache[45] || (_cache[45] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                  _createTextVNode("正在加载桌位... ", -1)
                ])))
              : (availableReservationTables.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, " 暂无可用普通桌位 "))
                : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableReservationTables.value, (table) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: table.tableId,
                        class: _normalizeClass(["p-4 border-2 rounded-lg text-left transition-colors", 
              selectedReservationTableId.value === table.tableId
                ? 'border-purple-500 bg-purple-50'
                : 'border-gray-200 hover:border-purple-300'
            ]),
                        disabled: isChangingReservationTable.value,
                        onClick: ($event: any) => (selectedReservationTableId.value = table.tableId || null)
                      }, [
                        _createElementVNode("div", _hoisted_80, _toDisplayString(table.tableName || '未命名桌位'), 1),
                        _createElementVNode("div", _hoisted_81, _toDisplayString(table.seatsDesc || `${table.seats || 0}人桌`), 1)
                      ], 10, _hoisted_79))
                    }), 128))
                  ])),
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("button", {
                class: "flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg",
                disabled: isChangingReservationTable.value,
                onClick: closeReservationTableModal
              }, " 取消 ", 8, _hoisted_83),
              _createElementVNode("button", {
                class: _normalizeClass(["flex-1 py-3 rounded-lg text-white font-medium", 
              selectedReservationTableId.value && !isChangingReservationTable.value
                ? 'bg-purple-600 hover:bg-purple-700'
                : 'bg-gray-400 cursor-not-allowed'
            ]),
                disabled: !selectedReservationTableId.value || isChangingReservationTable.value,
                onClick: confirmReservationTable
              }, [
                (isChangingReservationTable.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_85, _cache[46] || (_cache[46] = [
                      _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                      _createTextVNode("处理中... ", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_86, "确认并发送到厨房"))
              ], 10, _hoisted_84)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (paymentConfirmModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _cache[48] || (_cache[48] = _createElementVNode("h3", { class: "text-xl font-bold" }, "选择支付方式", -1)),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed",
                disabled: isConfirmingPayment.value,
                onClick: hidePaymentConfirmModal
              }, _cache[47] || (_cache[47] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]), 8, _hoisted_90)
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-gray-600" }, "订单号:", -1)),
                _createElementVNode("span", _hoisted_93, _toDisplayString(currentPaymentOrder.value?.orderNo || ''), 1)
              ]),
              _createElementVNode("div", _hoisted_94, [
                _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-gray-600" }, "桌号:", -1)),
                _createElementVNode("span", _hoisted_95, _toDisplayString(currentPaymentOrder.value?.tableName || ''), 1)
              ]),
              _createElementVNode("div", _hoisted_96, [
                _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-gray-600" }, "应付金额:", -1)),
                _createElementVNode("span", _hoisted_97, " ¥" + _toDisplayString((
                  currentPaymentOrder.value?.remainAmount ||
                  currentPaymentOrder.value?.totalAmount ||
                  0
                ).toFixed(2)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", null, [
                _cache[52] || (_cache[52] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 支付方式 ", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedPaymentMethod).value = $event)),
                  disabled: isConfirmingPayment.value,
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-lg"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentMethods.value, (method) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: method.value,
                      value: method.value
                    }, _toDisplayString(method.name), 9, _hoisted_100))
                  }), 128))
                ], 8, _hoisted_99), [
                  [_vModelSelect, selectedPaymentMethod.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[53] || (_cache[53] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 备注信息 ", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((paymentRemark).value = $event)),
                  disabled: isConfirmingPayment.value,
                  placeholder: "请输入备注信息（可选）",
                  rows: "3",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-base resize-none"
                }, null, 8, _hoisted_101), [
                  [_vModelText, paymentRemark.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("button", {
                class: "flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed",
                disabled: isConfirmingPayment.value,
                onClick: hidePaymentConfirmModal
              }, " 取消 ", 8, _hoisted_103),
              _createElementVNode("button", {
                class: "flex-1 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed",
                disabled: isConfirmingPayment.value,
                onClick: handlePaymentConfirm
              }, [
                (isConfirmingPayment.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_105, _cache[54] || (_cache[54] = [
                      _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                      _createTextVNode("处理中... ", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_106, "确认支付"))
              ], 8, _hoisted_104)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (scanPaymentModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
          _createElementVNode("div", { class: "bg-black bg-opacity-80 text-white px-4 py-3 flex items-center justify-between" }, [
            _createElementVNode("button", {
              class: "text-white",
              onClick: hideScanPaymentModal
            }, _cache[55] || (_cache[55] = [
              _createElementVNode("i", { class: "fas fa-times text-2xl" }, null, -1)
            ])),
            _cache[56] || (_cache[56] = _createElementVNode("h3", { class: "text-xl font-bold" }, "B扫C收款", -1)),
            _cache[57] || (_cache[57] = _createElementVNode("div", { class: "w-8" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_108, [
            _cache[59] || (_cache[59] = _createElementVNode("div", {
              id: "qr-reader",
              class: "qr-reader-container w-full h-full"
            }, null, -1)),
            (isScanning.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_109, _cache[58] || (_cache[58] = [
                  _createElementVNode("div", { class: "scan-line" }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          (scanStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                _createElementVNode("div", {
                  class: _normalizeClass(["p-3 rounded-lg text-center", scanStatusClass.value])
                }, [
                  _createElementVNode("p", _hoisted_111, _toDisplayString(scanStatus.value), 1)
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (scanPaymentFailModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
          _createElementVNode("div", _hoisted_113, [
            _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
              _cache[61] || (_cache[61] = _createElementVNode("h3", { class: "text-xl font-bold" }, "支付确认", -1)),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700",
                onClick: cancelScanPaymentConfirm
              }, _cache[60] || (_cache[60] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_114, [
              _cache[62] || (_cache[62] = _createElementVNode("p", { class: "text-gray-700 text-lg" }, "支付结果未确认，请选择下一步操作。", -1)),
              (scanPaymentFailErrorMsg.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_115, " 错误信息：" + _toDisplayString(scanPaymentFailErrorMsg.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_116, [
              _createElementVNode("button", {
                disabled: isRefreshingPayment.value,
                class: _normalizeClass([
              'w-full py-3 rounded-lg transition-colors font-medium',
              isRefreshingPayment.value
                ? 'bg-gray-400 text-white cursor-not-allowed'
                : 'bg-green-500 text-white hover:bg-green-600',
            ]),
                onClick: confirmScanPaymentPaid
              }, [
                (isRefreshingPayment.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_118, _cache[63] || (_cache[63] = [
                      _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                      _createTextVNode("查询支付结果中 ", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_119, "重新查询支付结果"))
              ], 10, _hoisted_117),
              _createElementVNode("button", {
                disabled: isRefreshingPayment.value,
                class: "w-full py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed",
                onClick: retryScanPayment
              }, " 重新扫码支付 ", 8, _hoisted_120),
              _createElementVNode("button", {
                disabled: isRefreshingPayment.value,
                class: "w-full py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:text-gray-400 disabled:cursor-not-allowed",
                onClick: cancelScanPaymentConfirm
              }, " 取消 ", 8, _hoisted_121)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: showOrderDetails.value,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((showOrderDetails).value = $event)),
      position: "center",
      round: "",
      style: { width: '96vw', maxWidth: '1200px', height: '92dvh' },
      onClosed: onOrderDetailsClosed
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_122, [
          _createElementVNode("div", _hoisted_123, [
            _cache[65] || (_cache[65] = _createElementVNode("span", { class: "font-semibold" }, "订单详情", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "px-2 py-1 text-gray-600",
              "aria-label": "关闭订单详情",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (showOrderDetails.value = false))
            }, _cache[64] || (_cache[64] = [
              _createElementVNode("i", { class: "fas fa-times mr-1" }, null, -1),
              _createTextVNode("关闭 ", -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_124, [
            (detailOrder.value)
              ? (_openBlock(), _createBlock(OrderDetailView, {
                  key: detailOrder.value.orderId,
                  "detail-order": detailOrder.value
                }, null, 8, ["detail-order"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 512))
}
}

})